"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionSignalMappingComparison = exports.FunctionSignalMappingRowSchema = void 0;
exports.functionSignalMappingRowKey = functionSignalMappingRowKey;
const z = require("zod");
const value_comparison_1 = require("../../Comparison/value-comparison");
const signal_name_normalization_1 = require("../../DataScience/signal-hygiene/signal-name-normalization");
const comparison_spec_1 = require("../comparison-spec");
exports.FunctionSignalMappingRowSchema = z.object({
    functionName: z.string(),
    functionSignalName: z.string(),
    signalNames: z.string().array(),
});
function functionSignalMappingRowKey(functionName, functionSignalName) {
    return [(0, value_comparison_1.normalizeForComparison)(functionName), (0, signal_name_normalization_1.normalizeSignalNameForComparison)(functionSignalName)].join('\x1F');
}
class FunctionSignalMappingComparison extends comparison_spec_1.ComparisonSpec {
    constructor() {
        super(...arguments);
        this.alignment = new comparison_spec_1.CellAlignment(['functionName', 'functionSignalName'], ['signalNames']);
    }
    toRows(data) {
        return data;
    }
    fromRows(rows) {
        return rows;
    }
    rowKeyOf(row) {
        return (0, value_comparison_1.compositeKey)(row, this.alignment.keyColumns.map(String), (column, value, rowContext) => this.normalize(column, value, rowContext));
    }
    normalize(column, value, row) {
        if (column === 'functionSignalName' && typeof value === 'string') {
            return (0, signal_name_normalization_1.normalizeSignalNameForComparison)(value);
        }
        if (column === 'signalNames' && Array.isArray(value)) {
            const canonical = value
                .map((name) => (typeof name === 'string' ? (0, signal_name_normalization_1.normalizeSignalNameForComparison)(name) : String(name)))
                .sort();
            return JSON.stringify(canonical);
        }
        return super.normalize(column, value, row);
    }
}
exports.FunctionSignalMappingComparison = FunctionSignalMappingComparison;
//# sourceMappingURL=function-signal-mapping.comparison.js.map